import { parseTaskMentionSegments } from "@/components/atomic-crm/tasks/taskMentions";
import { cn } from "@/lib/utils";

/** Note text with @mentions highlighted. */
export const ThreadMentionText = ({
  text,
  className,
}: {
  text?: string | null;
  className?: string;
}) => (
  <p className={cn("text-sm whitespace-pre-line break-words", className)}>
    {parseTaskMentionSegments(text ?? "").map((segment, index) =>
      segment.type === "text" ? (
        <span key={index}>{segment.value}</span>
      ) : (
        <span key={index} className="font-medium text-primary">
          @{segment.name}
        </span>
      ),
    )}
  </p>
);
